import { Ticker } from 'pixi.js';
import cloneDeep from 'lodash/cloneDeep';
import type { CurvedText } from './CurvedText';

export function animateCurvedTextJiggle(
  text: CurvedText,
  pointOffset = 0.33,
  offsetIncrement = 0.001,
  autoStart = true,
): {
  start: () => void;
  stop: () => void;
} {
  const ticker = new Ticker();
  let offset = 0;

  const { points } = text;
  const originalPoints = cloneDeep(points);

  ticker.add(({ deltaTime }) => {
    for (let i = 0; i < points.length; i += 1) {
      const point = points[i];
      offset += offsetIncrement * deltaTime;
      point.y = originalPoints[i].y + Math.sin(offset + i * pointOffset);
      point.x = originalPoints[i].x - Math.cos(offset + i * pointOffset);
    }
  });

  text.on('destroyed', () => {
    ticker.stop();
    ticker.destroy();
  });

  if (autoStart) ticker.start();

  return {
    start: ticker.start.bind(ticker),
    stop: ticker.stop.bind(ticker),
  };
}
